import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
  Collapse,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material'
import { useMemo, useState } from 'react'

export interface IOvPasswordInput extends Omit<TextFieldProps<'outlined'>, 'type'> {
  onChangeCallback?: (value: string) => void
  key?: any
  value?: any
  helperText?: string
  readOnly?: boolean
}

export const OvPasswordInput = ({
  error,
  helperText = '',
  onChangeCallback,
  key,
  label,
  value,
  size,
  readOnly,
  sx,
  ...rest
}: IOvPasswordInput) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleChange = (newValue: any) => {
    if (onChangeCallback) onChangeCallback(newValue)
  }

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev)
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const generateInputId = useMemo(() => `password-input_${label}-component-${Math.random()}`, [label])

  return (
    <FormControl
      variant="outlined"
      error={error}
      size={size}
      sx={{ minWidth: { md: 130 }, width: '100%', ...sx }}>
      <TextField
        sx={sx}
        size={size}
        id={generateInputId}
        error={error}
        key={key}
        disabled={readOnly}
        value={value}
        onChange={e => handleChange(e.target.value)}
        label={label}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleTogglePassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
                disabled={readOnly}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...rest}
      />
      <Collapse in={!!helperText}>
        <FormHelperText>{helperText}</FormHelperText>
      </Collapse>
    </FormControl>
  )
}
